import { render, staticRenderFns } from "./survey.vue?vue&type=template&id=4254ab39&"
import script from "./survey.vue?vue&type=script&lang=js&"
export * from "./survey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4254ab39')) {
      api.createRecord('4254ab39', component.options)
    } else {
      api.reload('4254ab39', component.options)
    }
    module.hot.accept("./survey.vue?vue&type=template&id=4254ab39&", function () {
      api.rerender('4254ab39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/user-manage/survey/survey.vue"
export default component.exports